export const menuConfig = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "LayoutDashboard",
    path: "/admin",
    type: "item",
  },
  {
    id: "chats",
    label: "Chats",
    icon: "MessageSquare",
    path: "/admin/chats",
    type: "item",
    badge: {
      type: "info",
      text: "AI",
    },
  },
  {
    id: "agents",
    label: "AI Agents",
    icon: "Bot",
    path: "/admin/agents",
    type: "item",
    badge: {
      type: "success",
      text: "AI",
    },
  },
  {
    id: "channels",
    label: "Channels",
    icon: "Smartphone",
    path: "/admin/channels",
    type: "item",
  },
];
